import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../lib/firebase";
import { products as staticProducts } from "../data/products";

export function useProducts() {
  const [products, setProducts] = useState(staticProducts);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    getDocs(collection(db, "products"))
      .then((snapshot) => {
        if (cancelled) return;
        if (snapshot.empty) {
          setIsLoading(false);
          return;
        }

        const fetched = snapshot.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: data.id ?? docSnap.id,
            name: data.name || "",
            sku: data.sku || "",
            sub: data.sub || "",
            price: typeof data.price === "number" ? `$${data.price}` : data.price || "$0",
            oldPrice: data.oldPrice
              ? typeof data.oldPrice === "number"
                ? `$${data.oldPrice}`
                : data.oldPrice
              : undefined,
            category: data.category || "",
            label: data.label || undefined,
            image: data.image || {},
            defaultImage: data.defaultImage || "",
            button: data.button || "Shop Now",
            colors: data.colors || {},
            description: data.description || "",
            seoDescription: data.seoDescription || "",
            features: data.features || [],
          };
        });

        setProducts(fetched);
        setIsLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { products, isLoading, error };
}
